/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MeRolesResponse } from '../../models/me-roles-response';

export interface MeRolesGet$Params {
  caseType?: string;
}

export function meRolesGet(http: HttpClient, rootUrl: string, params?: MeRolesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<MeRolesResponse>> {
  const rb = new RequestBuilder(rootUrl, meRolesGet.PATH, 'get');
  if (params) {
    rb.query('caseType', params.caseType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MeRolesResponse>;
    })
  );
}

meRolesGet.PATH = '/me/roles';
